// extracted by mini-css-extract-plugin
export default {"menu":"main-menu_menu__M1+FB","menu-item":"main-menu_menu-item__q2AzP","menu-item-button":"main-menu_menu-item-button__PTg0b"};